import { jsx as _jsx } from "react/jsx-runtime";
import { ElementIntent } from '../../enums';
import toast from 'react-hot-toast';
import { Toast } from './toast';
import { CheckIcon } from '../../icons';
import { ToastStrategyFactory } from './toast-strategy-factory';
import { ToastType, Action } from './toast-types';
const getTitleForIntent = (intent) => {
    switch (intent) {
        case ElementIntent.Success:
            return 'Success';
        case ElementIntent.Danger:
            return 'Error';
        case ElementIntent.Warning:
            return 'Warning';
        case ElementIntent.Info:
            return 'Info';
    }
};
export class ToastHelper {
    static getMessageForIntent(strategy, intent, action) {
        switch (intent) {
            case ElementIntent.Success:
                return strategy.getSuccessMessage(action);
            case ElementIntent.Danger:
                return strategy.getErrorMessage(action);
            case ElementIntent.Warning:
                return strategy.getWarningMessage(action);
            case ElementIntent.Info:
            default:
                return strategy.getInfoMessage(action);
        }
    }
    static createToast(intent, title, message) {
        toast.custom((t) => (_jsx("div", { style: {
                ...t.style,
                animation: t.visible
                    ? 'toast-bounce-enter 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
                    : 'toast-fade-exit 0.3s ease-out forwards',
            }, children: _jsx(Toast, { intent: intent, title: title, message: message, icon: CheckIcon, onDismiss: () => toast.dismiss(t.id) }) })), {
            duration: 5000,
        });
    }
    static show(messageOrEntityType, intent, action) {
        const isToastType = Object.values(ToastType).includes(messageOrEntityType);
        if (!isToastType) {
            this.createToast(intent, getTitleForIntent(intent), messageOrEntityType);
            return;
        }
        const strategy = ToastStrategyFactory.getStrategy(messageOrEntityType);
        const { title, message } = this.getMessageForIntent(strategy, intent, action);
        this.createToast(intent, title, message);
    }
    // Generic methods
    static success(message) {
        this.show(message, ElementIntent.Success);
    }
    static error(message) {
        this.show(message, ElementIntent.Danger);
    }
    static warning(message) {
        this.show(message, ElementIntent.Warning);
    }
    static info(message) {
        this.show(message, ElementIntent.Info);
    }
    // Action-based methods
    static createSuccess(entityType) {
        this.show(entityType, ElementIntent.Success, Action.Create);
    }
    static updateSuccess(entityType) {
        this.show(entityType, ElementIntent.Success, Action.Update);
    }
    static deleteSuccess(entityType) {
        this.show(entityType, ElementIntent.Success, Action.Delete);
    }
    static createError(entityType) {
        this.show(entityType, ElementIntent.Danger, Action.Create);
    }
    static updateError(entityType) {
        this.show(entityType, ElementIntent.Danger, Action.Update);
    }
    static deleteError(entityType) {
        this.show(entityType, ElementIntent.Danger, Action.Delete);
    }
}
